import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';
import { exibirMensagem } from '../../redux/actions/mensagemAction';
import ambiente from '../../config/ambienteConfig';
import ContasForm from './ContasForm';
import ContasRow from './ContasRow';

class Contas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            contas: [],
            conta: { id: '', nome: '', visivel: true },
        };
    }

    componentDidMount = () => {
        this.atualizarContas();
    }

    atualizarContas = async () => {
        try {
            const res = await axios.get(`${ambiente.dev.server}/contasAdmin`);
            this.setState({ contas: res.data });
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    handleChangeNome = (evt) => {
        let conta = {...this.state.conta};
        conta.nome = evt.target.value;
        this.setState({ conta });
    }

    handleChangeVisibilidade = (evt) => {
        let conta = {...this.state.conta};
        conta.visivel = !this.state.conta.visivel;
        this.setState({ conta });
    }

    handleSave = async () => {
        try {
            if(this.state.conta.id) {
                await axios.put(`${ambiente.dev.server}/contas/${this.state.conta.id}`, 
                    { nome: this.state.conta.nome, visivel: this.state.conta.visivel });
                this.props.exibirMensagem('yay', 'Conta atualizada com sucesso!');
            } else {
                await axios.post(`${ambiente.dev.server}/contas`, 
                    { nome: this.state.conta.nome, visivel: this.state.conta.visivel });
                this.props.exibirMensagem('yay', 'Conta inserida com sucesso!');
            }
            this.setState({ conta: {id: '', nome: '', visivel: true } });
            this.atualizarContas();
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    handleDelete = async (id) => {
        try {
            await axios.delete(`${ambiente.dev.server}/contas/${id}`);
            this.atualizarContas();
            this.props.exibirMensagem('yay', 'Conta excluída com sucesso!');
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    render() {
        return (
            <div>
                <h2>Contas</h2>
                <ContasForm conta={this.state.conta} handleChangeNome={this.handleChangeNome}
                    handleChangeVisibilidade={this.handleChangeVisibilidade} handleSave={this.handleSave} />
                <table className="table">
                    <thead>
                        <tr>
                            <th>Conta</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        { this.state.contas && 
                            this.state.contas.map(item => 
                                <ContasRow key={item.id} conta={item}
                                    handleDelete={this.handleDelete}
                                    handleUpdate={conta => this.setState({ conta })} />) }
                    </tbody>
                </table>
            </div>
        );
    }
}

Contas.propTypes = {
    exibirMensagem: PropTypes.func.isRequired
  };
  
  function mapStateToProps(state) {
    return {};
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto))
    };
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(Contas);
  


// WEBPACK FOOTER //
// ./src/components/contas/Contas.js